"use strict";
import Common from "./Common";

const disp = [];

export default class SplashScene extends p3.Scene {
    constructor() {
        super();
        /**
         * @type {number}
         */
        this.tileSize = 1020;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._bg = null;

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._primaryHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._uiHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._bgHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._midHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._fgHolder = new PIXI.Container();

        /**
         * @type {null}
         */
        this.dragging = null;

        /**
         * @type {Array}
         * @private
         */
        this._happos = [];

        /**
         * @type {Array}
         * @private
         */
        this._containers = [];

        /**
         * @type {null}
         */
        this.sky = null;

        /**
         * @type {null}
         */
        this.soundBtn = null;

        /**
         * @type {null}
         */
        this.logo = null;
    }

    init() {
        /*
         let test = createSprite("happo_1", this._uiHolder);

         let lerp = (obj, time, target) => {
         time *= 1000; //to ms
         let startTime = Date.now();
         var lerper = () => {
         const elapsed = Date.now() - startTime;
         //console.log(elapsed + " : " + time);
         if (elapsed >= time) return;
         const perc = (Common.toPercent(time, elapsed)) / 100;
         const updated = Common.lerp(obj, target, perc / 100);
         obj.x = updated.x;
         obj.y = updated.y;
         //console.log(obj.x + ", " + obj.y);
         setTimeout(lerper, 16.6);
         };
         lerper();
         };
         let targ = {x: 250, y: 250};

         delay(()=> {
         lerp(test, 10, targ);
         }, 3, this);
         */
        //load saved data if it exists
        Common.loadGame();

        //add to containers
        this.addChild(this._bgHolder, this._midHolder, this._fgHolder, this._primaryHolder, this._uiHolder);
        this._containers = [this._bgHolder, this._midHolder, this._fgHolder, this._primaryHolder, this._uiHolder];

        //create bg
        // this._bg = createSprite("bg", this._primaryHolder);

        //init ui elements
        this.initUI();

        //init display objects
        this.initDisp();

        Common.audio.playMusic("music_mainmenu_loop_00");

        ///TweenMax.from(this, 8, {x: p3.View.width});
        this.addDeco();

        this.start();

        //animate in
        const tweenTime = 1.5;
        TweenMax.from(this.mountainTiles.tilePosition, tweenTime, {x: 200, ease: Power1.easeOut});
        for (let i in this.clouds) {
            TweenMax.from(this.clouds[i], tweenTime, {x: this.clouds[i].x + 200, ease: Power1.easeOut});
        }
        TweenMax.from(this.midTiles.tilePosition, tweenTime, {x: 800, ease: Power1.easeOut});

        TweenMax.from(this.floorTiles.tilePosition, tweenTime, {x: 1200, ease: Power1.easeOut});
        for (let i in this.happos) {
            TweenMax.from(this.happos[i], tweenTime, {x: this.happos[i].x + 1200, ease: Power1.easeOut});
            if (this.happos[i].shadow) {
                this.happos[i].shadow.position.set(this.happos[i].x, this.happos[i].y + 5);
                TweenMax.from(this.happos[i].shadow, tweenTime, {x: this.happos[i].x + 1200, ease: Power1.easeOut});
            }
        }
        TweenMax.from(this.banner, tweenTime, {
            x: this.banner.x + 1200, ease: Power1.easeOut, onComplete: ()=> {
                this.finishAnim()
            }
        });
        //TweenMax.from(this.banner, 3, {x: 1200, ease: Power1.easeOut});
    }

    finishAnim() {
        TweenMax.to(this.playBtn.scale, 0.5, {x: 1, y: 1, ease: Bounce.easeOut});
        TweenMax.to(this.soundBtn.scale, 0.5, {x: 1, y: 1, ease: Bounce.easeOut});
        TweenMax.to(this.logo.scale, 0.5, {x: 0.9, y: 0.9, ease: Bounce.easeOut});
    }

    jumpHappo() {
        const delayTime = 4;
        var jump = () => {
            const rand = Math.floor(Math.random() * this._happos.length);
            const happo = this._happos[rand];
            happo.tween.pause();
            TweenMax.to(happo, 0.25, {y: happo.y - 25, yoyo: true, repeat: 1});
            TweenMax.to(happo.scale, 0.25, {
                x: happo.scale.x - 0.05,
                y: happo.scale.y + 0.05,
                yoyo: true,
                repeat: 1,
                onComplete: ()=> {
                    happo.tween.resume();
                }
            });
        };
        delay(jump, delayTime, this);
    }

    addDeco() {

        let bgTiles = createSprite("sky", this._bgHolder);
        //bgTiles.x = -p3.View.width * 0.5;
        bgTiles.width = p3.View.width + 200;
        bgTiles.height = p3.View.height + 210;

        let floor = new PIXI.extras.TilingSprite(Common.assets.getTexture("ground"), this.tileSize * 3, 550 / 2);
        floor.position.x = -2040;
        floor.position.y = p3.View.height * 0.5 + 50;
        floor.scale.y = 1.25;

        let mountains = new PIXI.extras.TilingSprite(Common.assets.getTexture("mountains_bg"), this.tileSize * 3, 466 / 2);
        mountains.position.x = -2040;
        mountains.position.y = p3.View.height * 0.5 - 250;
        mountains.scale.set(2);

        let mid = new PIXI.extras.TilingSprite(Common.assets.getTexture("mid_ground"), this.tileSize * 3, 500 / 2);
        mid.position.x = -2040;
        mid.position.y = p3.View.height * 0.5;

        disp.push(floor, mountains, mid);

        this.floorTiles = floor;
        this.mountainTiles = mountains;
        this.midTiles = mid;
        this.sky = bgTiles;

        this._fgHolder.addChild(floor);
        this._bgHolder.addChild(mountains);
        this._midHolder.addChild(mid);

        //let tree = createSprite("tree_midground", this._midBackHolder);

        //--add in clouds--//
        this.clouds = [];
        for (let i = 0; i < 5; i++) {
            let obj = createSprite("cloud_b_" + Math.ceil(Math.random() * 3), this._bgHolder);
            obj.x = i * 1000 - Math.random() * 2000;
            obj.y = (p3.View.height * 0.5) - 300 - Math.random() * 150;
            //obj.scale.set((Math.random() * 0.25) + 0.75);
            this.clouds.push(obj);
        }


    }

    start() {
        this._running = true;
        //--start happos randomly jumping--//
        this.jumpHappo();
        //  Common.smoothie.update = this.update.bind(this);
    }

    update() {
        if (this.dragging) {
            const pos = this.dragging.inputData.getLocalPosition(this);
            this.dragging.position.set(pos.x, pos.y);
        }
    }

    end() {
        this._running = false;
        this.signals.next.dispatch(this);
    }

    initUI() {
        let pressed = false; //probably don't need to, but client reported bug caused by spamming this button (the bug actually is because they manage to press input down on game scene before happpo is in cannon)
        var playClick = () => {
            if (pressed) return;
            pressed = true;
            this.signals.next.dispatch(this);
        };
        const btnPlay = Common.createButton(0, p3.View.height * 0.5 + 225, "big", playClick, this, this._uiHolder, "icon_play");
        btnPlay.scale.set(0);
        this.playBtn = btnPlay;

        var muteClick = () => {
            Common.isMute = !Common.isMute;
            Common.audio.mute(Common.isMute);
            if (!Common.isMute) this.soundBtn.icon.texture = Common.assets.getTexture("icon_sound_on");
            else this.soundBtn.icon.texture = Common.assets.getTexture("icon_sound_off");
        };
        this.soundBtn = Common.createButton(p3.View.width * 0.5 - 75, 65, "small", muteClick, this, this._uiHolder, "icon_sound_off");
        if (!Common.isMute) this.soundBtn.icon.texture = Common.assets.getTexture("icon_sound_on");
        this.soundBtn.scale.set(0);
        /*
         var homeClick = () => {
         open(Common.homeURL);
         };
         const btnHome = Common.createButton(-p3.View.width * 0.5 + 75, 65, "small", homeClick, this, this._uiHolder, "icon_home");
         */
    }

    initDisp() {

        const tree = createSprite("tree_transparent", this._primaryHolder);
        tree.x = -p3.View.width * 0.5 + 125;
        tree.y = -75;

        const pond = createSprite("water_hole_fg", this._primaryHolder);
        pond.anchor.set(0.5, 1);
        pond.y = p3.View.height;
        pond.x = 125;

        let banner = createSprite("banner", this._primaryHolder);
        banner.x = banner.y = 105;
        let txtView;
        if (Common.language === "ar") {
            txtView = p3.simpleText(Common.copy.title[Common.language], "arial", 120, null, 0xd21402);
        } else if (Common.language === "ru") {
            txtView = p3.simpleText(Common.copy.title[Common.language], "arial", 65, null, 0xd21402);
        } else {
            txtView = new PIXI.extras.BitmapText(Common.copy.title[Common.language], {
                font: "95px Ziclets",
                align: "center",
                tint: 0xd21402
            });
            txtView.maxWidth = 250;
            if (Common.language === "hu") {
                txtView.maxWidth = 600;
            }
            txtView.anchor.set(0.5);
        }

        banner.addChild(txtView);
        txtView.x = -140;
        txtView.y = 135;
        banner.scale.set(0.8);
        banner.y = 175;
        if (Common.language === "hu") {
            txtView.y += 10;
        }

        if (Common.language !== "en") {
            txtView.scale.set(0.65);
        }

        let logo = createSprite("happos_logo", this._primaryHolder);
        logo.y = 15;
        logo.scale.set(0);
        this.logo = logo;
        this.banner = banner;

        let happo2 = this.createHappo("happo_2", this._primaryHolder);
        happo2.x = 262;
        happo2.y = p3.View.height - 75;

        let happo1 = this.createHappo("happo_1", this._primaryHolder);
        happo1.x = -498;
        happo1.y = p3.View.height - 100;

        let stunt = createSprite("stunt_splash", this._primaryHolder);
        stunt.y = -15;
        stunt.x = 75;

        this.happos = [happo1, happo2, stunt, pond, tree];

        const bLogo = createSprite(Common.language == 'es' ? "preloader_es" : "boomerang_logo", this._primaryHolder);
        bLogo.x = p3.View.width * 0.5 - bLogo.width * 0.5 - 15;
        bLogo.y = p3.View.height - bLogo.height - 15;

        if(Common.language == 'es')
        {
            bLogo.scale = new PIXI.Point(0.4, 0.4);
            bLogo.y += 170;
        }

        this.bLogo = bLogo;

    }

    destroy() {
        TweenMax.killAll();

        //loop through display objects and destroy
        for (let i = 0; i < disp.length; i++) {
            disp[i].destroy();
            disp[i] = null;
            delete disp[i];
        }
        disp.length = 0;

        for (let i = 0; i < this._containers.length; i++) {
            this._containers[i].destroy();
            this._containers[i] = null;
            delete this._containers[i];
        }
        this._containers.length = 0;

        Common.audio.stopMusic("music_mainmenu_loop_00");

        super.destroy();
    }

    resize() {
        this.x = p3.View.width * 0.5;

        this.sky.width = p3.View.width + 200;
        this.sky.height = p3.View.height + 210;

        this.soundBtn.x = p3.View.width * 0.5 - 75;

        this.bLogo.x = p3.View.width * 0.5 - this.bLogo.width * 0.5 - 15;
    }

    createHappo(name, holder) {
        let shadow = createSprite("shadow", holder);
        let obj = createSprite(name, holder);
        obj.anchor.y = 1;
        //obj.scale.set(0.8);
        obj.tween = TweenMax.to(obj.scale, 1, {
            x: obj.scale.x + 0.02,
            y: obj.scale.y - 0.02,
            ease: Power0.easeNone,
            yoyo: true,
            repeat: -1,
            repeatDelay: 0.15 + Math.random * 0.2,
            delay: Math.random()
        });
        this._happos.push(obj);
        //obj.y += 15;
        shadow.anchor.set(0.5, 1);
        obj.shadow = shadow;
        disp.push(obj, shadow);
        return obj;
    }

    makeDraggable(sprite) {
        sprite.interactive = true;
        sprite.mousedown = (e) => {
            this.dragging = sprite;
            this.dragging.inputData = e.data;
        };
        sprite.mouseup = sprite.mouseupoutside = () => {
            console.log("dragXY : " + Math.round(this.dragging.x) + ", " + Math.round(this.dragging.y));
            this.dragging = null;
        };
    }
}

function createSprite(texture, holder) {
    let sprite;
    if (typeof texture === "string") sprite = new PIXI.Sprite(Common.assets.getTexture(texture));
    else if (texture instanceof PIXI.Texture) sprite = new PIXI.Sprite(texture);
    sprite.anchor = {x: 0.5, y: 0};
    if (holder) holder.addChild(sprite);
    disp.push(sprite);
    return sprite;
}